import { EMPTY_ROOT_CONTAINER_PROPS } from "@client/content/lib/consts";
import { getEntityRef } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { closeTicket, createComment, rate, updateViolation } from "../actions";
import { localStateSelector, makeUploadInfoSelector } from "../selectors";
import { type MemberHelpdesk } from "../types";
import Component, { type ActionProps, type MapProps } from "./component";

const INVISIBLE_PROPS: MapProps = {
  ...EMPTY_ROOT_CONTAINER_PROPS,
  detail: null,
  isEditMode: false,
  status: "None",
  canLeaveFeedback: false,
  surveyPageUrl: "",
  violations: null
};

const makeMapStateToProps = () => {
  const uploadApiInfoSelector = makeUploadInfoSelector(true);

  return (state: AppState, props: RootContainerProps & { onChange?: (name: string, value: any) => void }): MapProps => {
    const localState = localStateSelector(state, props);
    if (!localState.showingDetailId) return INVISIBLE_PROPS;

    const detail = localState.detail[localState.showingDetailId]!;

    return {
      ...props,
      canLeaveFeedback: localState.canLeaveFeedback,
      detail: detail.detail,
      isEditMode: state.isEditMode,
      status: detail.status,
      surveyPageUrl: localState.surveyPageUrl,
      uploadApiInfo: uploadApiInfoSelector(state, props),
      violations: localState.guidelineViolations?.filter((x) => x.ticketId === localState.showingDetailId)
    };
  };
};

const mapDispatchToProps = (
  dispatch: any,
  props: RootContainerProps & { onChange?: (name: string, value: any) => void }
): ActionProps => ({
  onSubmit: (data: MemberHelpdesk.View.NewComment) => dispatch(createComment(getEntityRef(props), data)),
  onCloseTicket: () => dispatch(closeTicket(getEntityRef(props))),
  onRate: (rating: number, ticketFeedbackQuestionId: string, permalink: string | null) =>
    dispatch(rate(getEntityRef(props), rating, ticketFeedbackQuestionId, permalink)),
  onChange: props.onChange,
  onCloseViolation: (data: string) => dispatch(updateViolation(getEntityRef(props), data))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
